import { create } from 'zustand';

export type LiveAnsweredByAgent = {
  id: number;
  name: string | null;
  avatarUrl: string | null;
};

export type CallAnsweredElsewhereStoreType = {
  clientId: number | null;
  messageConversationId: number | null;
  agent: LiveAnsweredByAgent | null;
};

export const useCallAnsweredElsewhereStore = create<CallAnsweredElsewhereStoreType>(() => ({
  clientId: null,
  messageConversationId: null,
  agent: null,
}));
